import React, { useEffect, useState, Fragment } from "react";
import Link from "next/link";
import Grid from "@mui/material/Grid";
import API from "@unisearch/helpers/api";
import styles from "./partner.module.scss";
import { arrayShuffler } from "@unisearch/helpers";

export const PartnerGrid = () => {
  const [partners, setPertners] = useState([]);

  useEffect(() => {
    let unmount = false;
    const featchPartners = async () => {
      await API.get(`/public/partner/universities?skip=0&limit=28`).then(
        (resp) => {
          if (!resp.error && resp.data) {
            if (resp.data && resp.data.length > 0) {
              let data = arrayShuffler(resp.data);
              setPertners(data);
            }
          }
        }
      );
    };
    featchPartners();
    return () => {
      unmount = true;
    };
  }, []);

  return (
    <>
      {partners?.length > 0 && (
        <section className={styles.section_partner}>
          <div className="container">
            <h2 className={`${styles.title} center`}>Our Partners</h2>
            <p className={`${styles.sub_title} font-xlarge center`}>
              Trusted by 500+ institutions globally
            </p>

            <Grid container spacing={2}>
              {partners?.slice(0, 12).map((item, i) => {
                return (
                  <Fragment key={i}>
                    {item?.universityLogoSrc && (
                      <Grid
                        item
                        xs={6}
                        sm={4}
                        md={4}
                        lg={2}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Link
                          legacyBehavior
                          href={`/study/${item?.countrySlug}/university/${item?.universitySlug}`}
                        >
                          <a>
                            <img
                              src={item?.universityLogoSrc}
                              alt={item?.universityName}
                            />
                          </a>
                        </Link>
                      </Grid>
                    )}
                  </Fragment>
                );
              })}
            </Grid>
          </div>
        </section>
      )}
    </>
  );
};

export default PartnerGrid;
